import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { Grid, Typography, Stack } from "@mui/material";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import { getQueries } from "../../apis";
import HRManagerCard from "./components/HRManagerCard";
import SelectedHRManager from "./components/SelectedHRManager";
import AdminDrawer from "../../components/AdminDrawer";

const HRManager = () => {
  const [queries, setQueries] = useState([]);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getQueries();
      setQueries(result.data.queries);
      setLoading(false);
    };

    fetchData();
  }, []);

  const HandleOnClick = (id) => {
    const filteredResult = queries.filter((item) => item._id == id);
    setSelectedQuery(filteredResult[0]);
  };

  const fetchNewData = async () => {
    const result = await getQueries();
    setQueries(result.data.queries);
    setLoading(false);
    setSelectedQuery(null);
  };

  return (
    <>
      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="HR Manager" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={5}>
                <Typography className="mb-16" variant="h6">
                  Queries
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {queries.length && loading == false ? (
                      queries.map((item) => (
                        <>
                          <HRManagerCard
                            title={item.title}
                            email={item.email}
                            id={item._id}
                            clickHandler={HandleOnClick}
                          />
                        </>
                      ))
                    ) : queries.length == 0 && loading == false ? (
                      <>
                        <Typography>No Queries Found</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div>
              </Grid>
              <Grid item sm={7}>
                {selectedQuery != null ? (
                  <SelectedHRManager
                    currentQueryDetails={selectedQuery}
                    handleFetchNewData={fetchNewData}
                  />
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default HRManager;
